import { render, staticRenderFns } from "./FormDesigner.vue?vue&type=template&id=e7b7d2b2&scoped=true"
import script from "./FormDesigner.vue?vue&type=script&lang=js"
export * from "./FormDesigner.vue?vue&type=script&lang=js"
import style0 from "./FormDesigner.vue?vue&type=style&index=0&id=e7b7d2b2&prod&scoped=true&lang=css"
import style1 from "./FormDesigner.vue?vue&type=style&index=1&id=e7b7d2b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b7d2b2",
  null
  
)

export default component.exports